import {
    LincolnshireRecordType,
    LincolnshireRecordSubType
} from "./LincolnshireRecordTypes";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from 'ol/style/RegularShape';

export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {               

                case LincolnshireRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case LincolnshireRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
                              
                case LincolnshireRecordSubType.RegisteredParkAndGarden:
                    style = this.RegisteredParksAndGardens();
                    break;

                case LincolnshireRecordSubType.ConservationArea:
                    style = this.ConservationArea();
                    break;

                case LincolnshireRecordSubType.RegisteredBattlefield:
                    style = this.RegisteredBattleField();
                    break; 

                case LincolnshireRecordSubType.ExtensiveUrbanSurvey:
                    style = this.ExtensiveUrbanSurvey();
                    break;                        
            }
        }

        if (style === null) {
            switch (recordType) {
                case LincolnshireRecordType.Monument:
                    style = this.Monument();
                    break;

                case LincolnshireRecordType.Event:
                    style = this.Event();
                    break;

                case LincolnshireRecordType.Designation:
                    style = this.Designation();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(
        recordType: string = LincolnshireRecordType.Monument): Style[]
    {        
        return this.SelectedRecord();
    }

    private CommonStyle(fillColour: string): Style[] {
        var fill = new Fill({
            color: fillColour
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,255,1)',
            width: 3
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    
    private Monument(): Style[] {      
        var fill = new Fill({            
            color: 'rgba(255, 69, 0, 0.6)'
        });
        var pointfill = new Fill({
            color: 'rgba(255, 0, 0, 0.9)'
        });
        var stroke = new Stroke({
            color: '#7F0000',
            width: 2
        });

        return   [
            new Style({
                image: new RegularShape({
                    fill: pointfill,
                    stroke: stroke,
                    points: 4,
                    radius: 4,
                    angle: Math.PI / 4,
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }

    private Event(): Style[] {
        var fill = new Fill({
            color: 'rgba(0, 0, 205, 0.5)'
        });
        var pointfill = new Fill({
            color: 'rgba(0, 0, 128, 0.9)'
        });
        var stroke = new Stroke({
            color: 'rgba(0, 0, 128, 1)',
            width: 2
        });

        return [
            new Style({
                image: new RegularShape({
                    fill: pointfill,
                    stroke: stroke,
                    points: 4,
                    radius: 4,
                    angle: Math.PI / 4,
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }

    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15,0.8)');
    }

    private RegisteredBattleField(): Style[] {      
        return [
            new Style({               
                fill: new Fill({
                    color: 'rgba(255, 255, 102, 0.8)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 1)',
                    width: 2
                })
            })
        ];
    }

    private ScheduledMonument(): Style[] {
        return [
            new Style({
                fill: new Fill({
                    color: 'rgba(255, 0, 255, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(186, 85, 211, 1)',
                    width: 2
                })
            })
        ];
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 234, 0, 0.6)'
        });
        var stroke = new Stroke({
            color: 'rgba(0, 0, 0, 1.0)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(255, 234, 0, 0.6)'
        });
        return [new Style({
            image: new Circle({
                fill: pointfill,
                stroke: stroke,              
                radius: 4
            }),
            fill: fill,
            stroke: stroke
        })];
    }


    private RegisteredParksAndGardens(): Style[] {
        return [
            new Style({
                fill: new Fill({
                    color: 'rgba(0, 255, 0, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(50, 205, 50, 1)',
                    width: 2
                })
            })
        ];
    }


    private ConservationArea(): Style[] {
        var fill = new Fill({
            color: 'rgba(135, 206, 235, 0.5)'
        });
        var pointfill = new Fill({
            color: 'rgba(135, 206, 235, 0.9)'
        });
        var stroke = new Stroke({
            color: 'rgba(0, 191, 255, 1)',
            width: 2
        });

        return [
            new Style({
                image: new Circle({
                    fill: pointfill,
                    stroke: stroke,
                    radius: 4
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }

    private ExtensiveUrbanSurvey(): Style[] {
        var fill = new Fill({
            color: 'rgba(238, 121, 12, 0.5)'
        });       
        var stroke = new Stroke({
            color: 'rgba(238, 121, 12, 1)',
            width: 2
        });

        return [
            new Style({              
                fill: fill,
                stroke: stroke
            })
        ];
    }
  
    private SelectedRecord(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 255, 0, 0.5)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(255, 173, 10, 1)',
                        width: 3
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(255, 173, 10, 1)',
                    width: 3
                })
            })
        ];
    }

}
